import React from 'react';

import { fg } from '@confluence/feature-gating';

import { CenteredContainer, CenteredContainerCompiled } from './presentationalComponents';
import { useTaskRowsContext } from './TaskRowsContext';

interface HeightAdjustedContainerProps {
	taskId: string;
	children: React.ReactNode;
	className?: string;
}

// Adjusts height according to description column.
export const HeightAdjustedContainer = ({
	taskId,
	children,
	className,
	...otherProps
}: HeightAdjustedContainerProps) => {
	const { taskRows } = useTaskRowsContext();
	const height = `${taskRows?.[taskId]?.rowHeight || 0}px`;

	if (fg('confluence_frontend_home_compiled_migration')) {
		return (
			<CenteredContainerCompiled
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
				className={className}
				// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
				style={{ height }}
				data-testid="height-adjusted-container"
				{...otherProps}
			>
				{children}
			</CenteredContainerCompiled>
		);
	}

	return (
		<CenteredContainer
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			className={className}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
			style={{ height }}
			data-testid="height-adjusted-container"
			{...otherProps}
		>
			{children}
		</CenteredContainer>
	);
};
